import React, { useEffect, useRef, useState } from 'react';
import './GlossarySidebarComponent.css';
import { glossaryTerm } from '../models/conversation';
import { Accordion, AccordionSummary, AccordionDetails, Typography } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import workAnalyzerService from '../services/workAnalyzerService';
import { Controlled as ControlledZoom } from 'react-medium-image-zoom';
import 'react-medium-image-zoom/dist/styles.css';

interface GlossarySidebarComponentProps {
  isOpen: boolean;
  toggleDrawer: () => void;
  glossary: glossaryTerm[];
  conversationId: string;
  diagramImageUrl: string | undefined;
}

const GlossarySidebarComponent: React.FC<GlossarySidebarComponentProps> = ({ isOpen, toggleDrawer, glossary, conversationId, diagramImageUrl }) => {
  const sidebarRef = useRef<HTMLDivElement>(null);
  const [isZoomed, setIsZoomed] = useState(false);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (sidebarRef.current && !sidebarRef.current.contains(event.target as Node) && !isZoomed) {
        toggleDrawer();
      }
    };

    if (isOpen) {
      document.addEventListener('mousedown', handleClickOutside);
    } else {
      document.removeEventListener('mousedown', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isOpen, toggleDrawer, isZoomed]);

  const handleZoomChange = (shouldZoom: boolean) => {
    setIsZoomed(shouldZoom);
  };

  return (
    <div ref={sidebarRef} className={`glossary-sidebar ${isOpen ? 'open' : ''}`}>
      <button className="close-button" onClick={toggleDrawer}>
        ×
      </button>
      <div className="glossary-content">
        <Typography variant="h5" sx={{ mb: 2 }} style={{marginTop:'60px'}}>
          Glossary
        </Typography>
        {glossary.filter(term => term.word.toLowerCase() !== 'diagram').map((item, index) => (
          <Accordion key={index} style={{ backgroundColor: '#ebebeb', boxShadow: 'none' }}>
            <AccordionSummary expandIcon={<ExpandMoreIcon />}>
              <Typography variant="subtitle1">{item.word}</Typography>
            </AccordionSummary>
            <AccordionDetails>
              <Typography variant="body2">
                {item.explanation}
              </Typography>
            </AccordionDetails>
          </Accordion>
        ))}
        {diagramImageUrl && (
          <div style={{ marginTop: 20 }}>
            <Typography variant="h6">Diagram</Typography>
            <ControlledZoom isZoomed={isZoomed} onZoomChange={handleZoomChange}>
              <img src={diagramImageUrl} alt="Diagram" style={{ width: '100%', height: 'auto', marginTop: 10 }} />
            </ControlledZoom>
          </div>
        )}
      </div>
    </div>
  );
};

export default GlossarySidebarComponent;
